import styled, { CSSProp } from 'styled-components';

export const ContentStyled = styled.div<{ $isImqSponsor: boolean }>`
  padding: ${({ $isImqSponsor }): CSSProp => ($isImqSponsor ? '6rem 7.2rem 4.8rem' : '3.2rem 7.2rem 4.8rem')};
  margin: 0;
  min-height: 100vh;
`;
